<div class="bm--loader-box">
  <bmcore-loader></bmcore-loader>
</div>
